import { createSlice } from "@reduxjs/toolkit";

const PageloadingSlice = createSlice({
  name: "loading",
  initialState: { isPageLoading: false },
  reducers: {
    setPageLoading: (state, action) => {
      state.isPageLoading = action.payload;
    },
  },
});

export const { setPageLoading } = PageloadingSlice.actions;
export default PageloadingSlice.reducer;
